/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Print_Standings_HintInputs */



/**
* | output |
* | --- |
* | "Print the standings as players see them" |
*
* @param {Players_Print_Standings_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_print_standings_hint = /** @type {((inputs?: Players_Print_Standings_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Print_Standings_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Imprimer le classement tel que les joueurs le voient")
	if (locale === "es") return /** @type {LocalizedString} */ ("Imprimir la clasificación tal como la ven los jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Imprimir a classificação como os jogadores a veem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stampa la classifica come la vedono i giocatori")
	return /** @type {LocalizedString} */ ("Print the standings as players see them")
});